import { Box, Typography } from "@mui/material"
import { makeStyles } from "tss-react/mui"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faChevronDown } from "@fortawesome/pro-solid-svg-icons"
import { StandardChip, StandardChipVariantType } from "../../../../../../shared/components/badges/StandardChip"
import { ProductStockInfo } from "../../productsTypes"
import { LocalizedStrict } from "../../../../../localization/components/AppLocalized"

type StyleProps = Readonly<{
    isOpen: boolean
}>

const useStyles = makeStyles<StyleProps>()((_, { isOpen }) => ({
    chipWrapper: {
        display: "inline-flex",
        alignItems: "center",
        cursor: "pointer",
        "&:hover": {
            opacity: 0.8,
        },
    },
    chipLabel: {
        display: "inline-flex",
        alignItems: "center",
        gap: "0.25rem",
    },
    chip: {
        cursor: "pointer",
    },
    chevron: {
        fontSize: "0.625rem",
        transition: "transform 0.2s ease",
        transform: isOpen ? "rotate(180deg)" : "rotate(0deg)",
    },
}))

type StockChipProps = Readonly<{
    stock: ProductStockInfo
    isOpen: boolean
    onClick: (event: React.MouseEvent<HTMLElement>) => void
}>

function getStockChipVariant(stock: ProductStockInfo): StandardChipVariantType {
    const total = stock.inventory?.total ?? 0
    const lowStockThreshold = stock.alerts?.minStock ?? 5
    if (total === 0) return "red"
    if (total <= lowStockThreshold) return "yellow"
    return "grey"
}

export function StockChip({ stock, isOpen, onClick }: StockChipProps) {
    const { classes } = useStyles({ isOpen })
    const variant = getStockChipVariant(stock)

    return (
        <Box className={classes.chipWrapper} onClick={onClick}>
            <StandardChip size="small" variant={variant} placement="table" className={classes.chip}>
                <Box component="span" className={classes.chipLabel}>
                    <LocalizedStrict id="product-stock-chip-label" vars={{ count: stock.inventory?.total ?? 0 }}>
                        <Typography variant="body2">{`Stock: ${stock.inventory?.total ?? 0}`}</Typography>
                    </LocalizedStrict>
                    <FontAwesomeIcon icon={faChevronDown} className={classes.chevron} />
                </Box>
            </StandardChip>
        </Box>
    )
}
